module.exports = __webpack_public_path__ + "static/media/Multi Country Pricing.8f30e00b.png";